export const registeredSMSCMutation = (builder) => ({
    getRegisteredSMSCAccounts: builder.mutation({
      query: ({ pageNumber, search, limit, sortBy, sortOrder}) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/get_smsc_details',
          method: 'GET',
          params: {
            pageNumber,
            search,
            limit,
            sortBy, 
            sortOrder
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  